import React, { useEffect, useRef } from "react";
import { Form, Button, Input } from "semantic-ui-react";
import Modal from "../Modal/Modal";

type AsyncModalFormProps = {
  title: string;
  isOpen: boolean;
  isSubmitting?: boolean;
  submitDisabled?: boolean;
  onSubmit: () => void;
  onClose: () => void;
  submitLabel?: string;
  children: React.ReactNode;
};

const AsyncModalForm: React.FC<AsyncModalFormProps> = ({
  title,
  isOpen,
  isSubmitting = false,
  submitDisabled = false,
  onSubmit,
  onClose,
  submitLabel = "OK",
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => {
        const firstInput = containerRef.current?.querySelector<HTMLInputElement>("input, textarea");
        firstInput?.focus();
      });
    }
  }, [isOpen]);

  return (
    <Modal title={title} onClose={onClose} isOpen={isOpen}>
      <div ref={containerRef}>
        <Form onSubmit={onSubmit}>
          {children}

          <Button
            primary
            // fluid
            type="submit"
            loading={isSubmitting}
            disabled={submitDisabled || isSubmitting}
            content={submitLabel}
          />
        </Form>
      </div>
    </Modal>
  );
};

type TextFieldProps = {
  label?: string;
  value: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onEnter?: () => void;
};

export const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  placeholder,
  disabled,
  onChange,
  onEnter,
}) => {
  return (
    <Form.Field>
      {label && <label>{label}</label>}
      <Input
        fluid
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        onChange={(e) => onChange(e.currentTarget.value)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter" && onEnter) {
            e.preventDefault();
            onEnter();
          }
        }}
      />
    </Form.Field>
  );
};

export default AsyncModalForm;
